<template>
  <div class="rh-header-main">
    <div class="rh-header-main-content">
      <div class="head-left">
        <a href="/">
          <img src="https://static.rhkj.com/renhe_fe/other/learning/logo.png" />
        </a>

        <div class="head-left-links">
          <a :href="`${baseHost}/`" class="hrf">首页</a>
          <a :href="`${baseHost}/main/allCourse/`" class="hrf">课程</a>
          <router-link :to="{ name: 'Questionbank' }" class="hrf">题库</router-link>
          <router-link :to="{ name: 'NewsIndex' }" class="hrf">资讯</router-link>
          <router-link :to="{ name: 'qaMain' }" class="hrf">问答</router-link>
          <!-- <a :href="`${baseHost}/web/helpSupport`" class="hrf">帮助与支持</a> -->
        </div>
      </div>

      <div class="head-right">
        <!-- 已登录 -->
        <template v-if="userInfo.token">
          <a href="/learning/studyCenter/courseUser">学习中心</a>
          <el-dropdown trigger="click" @command="command" popper-class="user-down-center">
            <div>
              {{ userInfo.userName }}
              <el-icon style="font-size: 12px;">
                <CaretBottom />
              </el-icon>
            </div>

            <template #dropdown>
              <el-dropdown-menu>
                <!--
                  <el-dropdown-item class="down-menu-item">
                    <a :href="`${baseHost}/web/uc/course/play/record/userStudyRecord`" class="down-link">
                      学习记录
                    </a>
                  </el-dropdown-item>
                -->
                <el-dropdown-item divided class="down-menu-item">
                  <a :href="`${baseHost}/web/uc/myInfo`" class="down-link">
                    个人资料
                  </a>
                </el-dropdown-item>
                <el-dropdown-item divided class="down-menu-item">
                  <a :href="`${baseHost}/web/pay/verified/info?type=3`" class="down-link">
                    实名认证
                  </a>
                </el-dropdown-item>
                <el-dropdown-item command="logOut" divided class="down-menu-item">
                  <div>
                    退出
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
        <!-- 未登录 -->
        <template v-else>
          <div class="login">
            <a href="/learning/login">登录</a>
            <!-- <span>/</span>
            <a href="/learning/register">注册</a> -->
          </div>

          <a class="app" href="/learning/static/app.html">
            <img src="https://static.rhkj.com/renhe_fe/other/learning/app.png">
            <span>APP</span>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { removeToken } from '@/utils/auth'
import useUserStore from "@/store/modules/user";
import { quitLogin } from "@/api/login";
import { localStorageClear, sessionStorageClear } from "@/utils/ruoyi.js";

const { userInfo } = useUserStore();

const props = defineProps({})
const router = useRouter();

const baseHost = inject('baseHost');
function command(arg) {
  if (arg == 'logOut') {
    quit()
  }
}
function quit() {
  quitLogin()
    .then(res => { })
    .catch((err) => { })
    .finally(() => {
      console.log('退出登录。。。。。')
      // 1.删除localStorage：适配新首页的nuxt项目(迁移至老网校)
      localStorageClear({
          exclude: ['invoiceV2'],
      });
      sessionStorage.clear()
      removeToken()
      // 2.获取所有cookie，并全部删除
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
      //3.页面跳转
      // if (location.hostname.indexOf('localhost') > -1) { // 本地环境
      //   location.href = '/learning/login';
      // } else {
      //   location.href = 'https://' + location.host + '/learning/login' // 线上转发到对应的网校登录页面
      // }
      router.push({
        path: '/login',
        replace: true
      })
    })
}
const goCenter = () => {
  router.push({
    path: '/studyCenter/courseUser',
  })
}
</script>

<style scoped lang="scss">
.rh-header-main {
  height: 58px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;

  .rh-header-main-content {
    width: 1200px;
    padding: 0 15px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    a {
      font-size: 15px;
      color: #444;
      cursor: pointer;
      display: inline-flex;
      align-items: center;

      &:hover {
        color: #337ab7;
      }
    }

    >div {
      display: flex;
      align-items: center;
    }

    .head-left {
      .head-left-links {
        display: flex;
        align-items: center;

        a {
          margin: 0 55px;
        }
      }
    }

    .head-right {
      .login {
        display: flex;
        align-items: center;
        margin-right: 20px;

        span {
          margin: 0 5px;
          font-size: 15px;
        }
      }

      .app {
        span {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
